export const validateCategoryToDisplayLengthFilter = (categoryId: any, lang: any) => {

    // Variant for mode with "mini, midi, maxi"
    const allowedCategoriesToDisplayLengthFilterV1 = [
        {
            "language": "en",
            "validCategories": [49, 32, 115, 117]
        },
        {
            "language": "rs",
            "validCategories": [39, 37, 117, 119]
        },
        {
            "language": "ba",
            "validCategories": [34, 32, 123, 125]
        },
        {
            "language": "hr",
            "validCategories": [35, 33, 81, 83]
        },
        {
            "language": "mk",
            "validCategories": [29, 31, 91, 93]
        },
        {
            "language": "me",
            "validCategories": [34, 36, 107, 109]
        },
        {
            "language": "al",
            "validCategories": [28, 26, 86, 88]
        },
        {
            "language": "si",
            "validCategories": [62, 61, 152, 155]
        },
        {
            "language": "us",
            "validCategories": [62, 65, 137, 139]
        },
        {
            "language": "nl",
            "validCategories": [40, 41]
        },
        {
            "language": "at",
            "validCategories": [52, 49, 156, 158],
        },
    ]

    // Variant for mode with "short, midi, long"
    const allowedCategoriesToDisplayLengthFilterV2 = [
        {
            "language": "en",
            "validCategories": [35, 36, 122, 123]
        },
        {
            "language": "rs",
            "validCategories": [45, 44, 124, 125]
        },
        {
            "language": "ba",
            "validCategories": [39, 40, 130, 131] 
        },
        {
            "language": "hr",
            "validCategories": [40, 41, 81, 83]
        },
        {
            "language": "mk",
            "validCategories": [37, 36, 91, 93]
        },
        {
            "language": "me",
            "validCategories": [41, 42, 114, 115]
        },
        {
            "language": "al",
            "validCategories": [34, 35, 93, 94]
        },
        {
            "language": "si",
            "validCategories": [68, 69, 160, 161]
        },
        {
            "language": "us",
            "validCategories": [69, 70, 146, 147]
        },
        {
            "language": "nl",
            "validCategories": [39]
        },
        {
            "language": "at",
            "validCategories": [45, 44, 162, 163],
        },
    ]

    let displayLengthFilter = {display: false, variant: ""};

    // v1 = display variant with "mini, midi, maxi"
    const filterStoresDataV1 = allowedCategoriesToDisplayLengthFilterV1.filter((data: any) => { return data.language === lang});
    if(filterStoresDataV1.length) {
        const storeDataV1 = filterStoresDataV1[0];

        if(storeDataV1 && storeDataV1.validCategories.includes(categoryId)) {
            displayLengthFilter.display = true;
            displayLengthFilter.variant = "v1";
        }
    }

    // v2 = display variant with "short, midi, long"
    const filterStoresDataV2 = allowedCategoriesToDisplayLengthFilterV2.filter((data: any) => { return data.language === lang});
    if(filterStoresDataV2.length) {
        const storeDataV2 = filterStoresDataV2[0];

        if(storeDataV2 && storeDataV2.validCategories.includes(categoryId)) {
            displayLengthFilter.display = true;
            displayLengthFilter.variant = "v2";
        }
    }

    return displayLengthFilter;
}